import React from 'react'
import { CardInfo } from '../../../components/CardInfo'
import ChartProgressBar from '../../../components/ChartProgressBar'

const BidAmountIgr = ({ t, formatMillions, bidAmount }) => {
    return (
        <div className="amounts">
            <div>
                <h3 className="chart-title">{t('one_pager_report.bid_amount')}</h3>
                <div className="chart-content" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr' }}>
                    <CardInfo title={t('one_pager_report.original')} data={`${formatMillions(bidAmount?.originalAmount)} MM`} />
                    <CardInfo title={t('one_pager_report.current_title')} data={`${formatMillions(bidAmount?.currentAmount)} MM`} />
                </div>
            </div>

            <div>
                <h3 className="chart-title">{t('one_pager_report.accumulate_disbursements')}</h3>
                <div className="chart-content">
                    <ChartProgressBar
                        completed={bidAmount?.disbursementPercent}
                        totalAmount={bidAmount?.disbursementAmount + bidAmount?.undisburstmentAmount}
                        disbursmentAmount={bidAmount?.disbursementAmount}
                    />
                </div>
            </div>
        </div>
    )
}

export default BidAmountIgr